/** Tự sinh bởi scripts/fetch-templates.mjs lúc build — không sửa tay. */
export default [
  {
    "slug": "bo-ho-so-tham-dinh-data-room",
    "kind": "tep",
    "title": "Bộ hồ sơ thẩm định (data room) cho startup gọi vốn",
    "excerpt": "52 tài liệu quỹ sẽ hỏi trong quá trình thẩm định, chia theo tám nhóm và theo từng bước, kèm lý do quỹ cần mỗi tài liệu. Có sẵn cột trạng thái, người phụ trách, hạn và đường dẫn file; sheet tiến độ tự đếm số tài liệu bắt buộc còn thiếu. Gồm cả giấy tờ đặc thù Việt Nam như sổ đăng ký cổ đông, quyết toán thuế và hồ sơ bảo hiểm xã hội.",
    "maMau": "DATA-ROOM-VN-V1",
    "nhom": "due-diligence",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "doSau": "standard",
    "nhanNgan": "52 tài liệu, 8 nhóm",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fbo-ho-so-tham-dinh-data-room%2Fv1%2Fbo-ho-so-tham-dinh-data-room-v1.xlsx?alt=media&token=2230c602-4074-4d4c-acad-1c14d5450b93",
    "filePath": "mau/bo-ho-so-tham-dinh-data-room/v1/bo-ho-so-tham-dinh-data-room-v1.xlsx",
    "fileName": "bo-ho-so-tham-dinh-data-room-v1.xlsx",
    "fileSize": 18703,
    "fileFormat": "xlsx",
    "fileEnUrl": "",
    "fileEnPath": "",
    "fileEnName": "",
    "fileEnSize": 0,
    "fileEnFormat": "",
    "fileEnPhienBan": 0,
    "lichSu": [],
    "bienSo": [
      "Trạng thái từng tài liệu",
      "Người phụ trách",
      "Hạn hoàn thành",
      "Đường dẫn file"
    ],
    "tabs": [
      {
        "ten": "Hướng dẫn",
        "moTa": "Dùng để làm gì, cách điền, quy ước màu và một dòng ví dụ."
      },
      {
        "ten": "Danh mục hồ sơ",
        "moTa": "52 tài liệu, mỗi dòng ghi rõ vì sao quỹ hỏi, cần có ở bước nào và mức ưu tiên."
      },
      {
        "ten": "Tiến độ",
        "moTa": "Tự đếm theo nhóm và theo bước thẩm định; nêu số tài liệu bắt buộc còn thiếu."
      }
    ],
    "luuY": [
      "Đây là mức chuẩn bị chung cho vòng pre-seed và seed tại Việt Nam. Mỗi quỹ có danh sách riêng — hãy hỏi thẳng quỹ bạn đang làm việc cùng và bổ sung vào cuối sheet.",
      "Mức hoàn thành trong sheet Tiến độ là mức hoàn thành biểu mẫu, không phải đánh giá khả năng gọi vốn.",
      "Đây không phải tư vấn pháp lý. Với hợp đồng đầu tư và thủ tục đăng ký góp vốn của nhà đầu tư nước ngoài, hãy làm việc với luật sư."
    ],
    "baiLienQuan": "quy-tiep-nhan-ho-so-den-giai-ngan",
    "congCu": [
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Soát hồ sơ pháp lý"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Rà mức sẵn sàng gọi vốn"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-09-23",
    "updatedAt": "2026-09-23"
  },
  {
    "slug": "cap-table-pha-loang-safe",
    "kind": "tep",
    "title": "Cap table cho vòng gọi vốn đầu tiên: SAFE, ESOP và pha loãng",
    "excerpt": "Bảng cổ phần đầy đủ cho startup gọi vốn lần đầu. Nhập số tiền và định giá, file tự tính giá chuyển đổi của từng SAFE, phần ESOP phải mở rộng, tỷ lệ còn lại của sáng lập qua bốn mốc, và số tiền từng bên nhận ở năm mức giá bán công ty.",
    "maMau": "CAP-TABLE-PRESEED-V1",
    "nhom": "co-phan",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "doSau": "standard",
    "nhanNgan": "",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fcap-table-pha-loang-safe%2Fv1%2Fcap-table-pha-loang-safe-v1.xlsx?alt=media&token=a280a1fe-43df-4e0f-bf6a-d9733ce22e9b",
    "filePath": "mau/cap-table-pha-loang-safe/v1/cap-table-pha-loang-safe-v1.xlsx",
    "fileName": "cap-table-pha-loang-safe-v1.xlsx",
    "fileSize": 39460,
    "fileFormat": "xlsx",
    "fileEnUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fcap-table-pha-loang-safe%2Fen-v1%2Fcap-table-pha-loang-safe-en-v1.xlsx?alt=media&token=764880c1-ed4a-4750-b0f4-493e70756601",
    "fileEnPath": "mau/cap-table-pha-loang-safe/en-v1/cap-table-pha-loang-safe-en-v1.xlsx",
    "fileEnName": "cap-table-pha-loang-safe-en-v1.xlsx",
    "fileEnSize": 38529,
    "fileEnFormat": "xlsx",
    "fileEnPhienBan": 1,
    "lichSu": [],
    "bienSo": [
      "Tổng số cổ phần và mệnh giá ghi trong điều lệ công ty",
      "Tỷ lệ chia giữa các sáng lập, đúng như sổ đăng ký cổ đông",
      "Tỷ lệ ESOP hiện có và tỷ lệ nhà đầu tư yêu cầu sau vòng",
      "Với từng SAFE hoặc trái phiếu chuyển đổi đã ký: số tiền, định giá trần, chiết khấu, ngày ký",
      "Số tiền dự kiến gọi và định giá pre-money của vòng sắp tới",
      "Bội số ưu đãi thanh toán ghi trong term sheet",
      "Lịch vesting của sáng lập: tổng thời gian, cliff, số tháng đã làm"
    ],
    "tabs": [
      {
        "ten": "Huong_dan",
        "moTa": "Quy ước màu, 5 bước điền và các giả định của mô hình"
      },
      {
        "ten": "Dau_vao",
        "moTa": "Toàn bộ ô nhập: sáng lập, ESOP, SAFE, vòng Seed, Series A, vesting, kịch bản thoái vốn"
      },
      {
        "ten": "Cap_Table",
        "moTa": "Số cổ phần và tỷ lệ của từng cổ đông qua 4 mốc, kèm khối tham số tính toán"
      },
      {
        "ten": "Chuyen_doi_SAFE",
        "moTa": "Giá theo định giá trần, giá theo chiết khấu, giá áp dụng và số cổ phần mỗi SAFE nhận"
      },
      {
        "ten": "Sang_lap_Vesting",
        "moTa": "Lịch vesting 48 tháng có cliff, số cổ phần đã vest và chưa vest tại tháng hiện tại"
      },
      {
        "ten": "Pha_loang",
        "moTa": "Tỷ lệ sở hữu và giá trị phần sở hữu của từng nhóm qua 4 mốc"
      },
      {
        "ten": "Thoai_von",
        "moTa": "Thứ tự chia tiền ở 5 mức giá bán, có ưu đãi thanh toán và quyết định chuyển đổi"
      },
      {
        "ten": "Tong_hop",
        "moTa": "Chỉ số chính, 4 cảnh báo tự động và 2 biểu đồ để gửi nhà đầu tư"
      },
      {
        "ten": "Kiem_tra",
        "moTa": "10 mục kiểm tra phải ĐẠT trước khi gửi file ra ngoài"
      }
    ],
    "luuY": [
      "SAFE được mô hình theo bản post-money (YC 2018 trở đi). Nếu bạn ký bản pre-money hoặc trái phiếu chuyển đổi có lãi, hãy cộng lãi tích luỹ vào cột Số tiền để ước lượng gần đúng và đối chiếu lại với luật sư.",
      "ESOP đặt theo tỷ lệ mục tiêu sau vòng, nên phần mở rộng quỹ pha loãng sáng lập chứ không pha loãng tiền mới. Đây là cách nhà đầu tư thường yêu cầu, và cũng là chỗ founder hay tính thiếu.",
      "Sheet Thoai_von giả định ưu đãi 1x không tham gia chia tiếp, hai nhóm ngang hàng, nhà đầu tư SAFE gộp chung nhóm với vòng Seed. Nếu term sheet của bạn có participating preferred hoặc nhiều lớp ưu đãi xếp hạng khác nhau, kết quả sẽ khác.",
      "File phục vụ lập kế hoạch và đàm phán. Nó không thay điều lệ, sổ đăng ký cổ đông hay ý kiến luật sư."
    ],
    "baiLienQuan": "cap-table-pha-loang-vong-dau",
    "congCu": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-09-21",
    "updatedAt": "2026-10-20"
  },
  {
    "slug": "dinh-gia-startup-dcf",
    "kind": "tep",
    "title": "Mẫu Excel định giá startup: DCF và 4 phương pháp đối chiếu",
    "excerpt": "Tính khoảng định giá pre-money bằng năm phương pháp nhà đầu tư thường dùng, gán trọng số theo giai đoạn và xem ngay tỷ lệ cổ phần phải nhượng. Mẫu có ví dụ một startup SaaS điền sẵn, bảng độ nhạy và mục tự kiểm tra lỗi.",
    "maMau": "VAL-CORE-SAAS-V1",
    "nhom": "dinh-gia",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed"
    ],
    "doSau": "lite",
    "nhanNgan": "",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fdinh-gia-startup-dcf%2Fv1%2Fdinh-gia-startup-dcf-v1.xlsx?alt=media&token=4baa5ce4-bcd4-48ba-b1cf-6b978b5b2d5e",
    "filePath": "mau/dinh-gia-startup-dcf/v1/dinh-gia-startup-dcf-v1.xlsx",
    "fileName": "dinh-gia-startup-dcf-v1.xlsx",
    "fileSize": 31271,
    "fileFormat": "xlsx",
    "fileEnUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fdinh-gia-startup-dcf%2Fen-v1%2Fdinh-gia-startup-dcf-en-v1.xlsx?alt=media&token=9ed85384-d6cc-406d-9616-9fb83c7307b6",
    "fileEnPath": "mau/dinh-gia-startup-dcf/en-v1/dinh-gia-startup-dcf-en-v1.xlsx",
    "fileEnName": "dinh-gia-startup-dcf-en-v1.xlsx",
    "fileEnSize": 30126,
    "fileEnFormat": "xlsx",
    "fileEnPhienBan": 1,
    "lichSu": [],
    "bienSo": [
      "Doanh thu 12 tháng gần nhất",
      "Tiền mặt hiện có và các khoản nợ vay",
      "Số vốn định gọi ở vòng này",
      "Dự phóng tăng trưởng doanh thu và biên EBITDA 5 năm (lấy từ mô hình tài chính nếu đã có)",
      "Bội số định giá của 3–5 công ty niêm yết hoặc thương vụ tương tự, kèm nguồn",
      "Định giá trung bình các vòng cùng giai đoạn trong khu vực (cho Scorecard)"
    ],
    "tabs": [
      {
        "ten": "Huong_dan",
        "moTa": "Quy ước màu ô, các bước dùng mẫu, chọn phương pháp theo giai đoạn và giới hạn của mẫu"
      },
      {
        "ten": "Dau_vao",
        "moTa": "Toàn bộ giả định ở một chỗ: vốn gọi, tiền mặt, nợ, doanh thu, tăng trưởng và biên EBITDA 5 năm, tỷ lệ chiết khấu, bội số"
      },
      {
        "ten": "DCF",
        "moTa": "Dòng tiền tự do 5 năm, giá trị cuối theo Gordon và bội số thoát, hai bảng độ nhạy"
      },
      {
        "ten": "So_sanh",
        "moTa": "Bội số EV/Doanh thu của công ty hoặc thương vụ tương tự, trung vị, tứ phân vị và chiết khấu thanh khoản"
      },
      {
        "ten": "PP_VC",
        "moTa": "Đi ngược từ giá trị lúc thoát vốn theo lợi nhuận mục tiêu của nhà đầu tư, có tính pha loãng các vòng sau"
      },
      {
        "ten": "Scorecard",
        "moTa": "Điều chỉnh định giá trung bình khu vực theo 7 tiêu chí có trọng số, dành cho startup chưa có doanh thu"
      },
      {
        "ten": "Berkus",
        "moTa": "Cộng giá trị cho 5 yếu tố giảm rủi ro, dành cho giai đoạn ý tưởng và nguyên mẫu"
      },
      {
        "ten": "Tong_hop",
        "moTa": "Pre-money có trọng số, post-money, tỷ lệ sở hữu, biểu đồ football field và mục kiểm tra"
      }
    ],
    "luuY": [
      "Chỉ sửa ô chữ xanh nền vàng; ô chữ đen là công thức",
      "Số trong mẫu là ví dụ minh hoạ, không phải dữ liệu thị trường — cần thay dữ liệu so sánh bằng số thật và ghi nguồn",
      "Giá trị tính theo triệu VNĐ; đổi đơn vị thì đổi đồng loạt mọi ô nhập",
      "Kết quả là điểm tựa để đàm phán với nhà đầu tư, không phải mức giá bắt buộc và không phải tư vấn đầu tư"
    ],
    "baiLienQuan": "dinh-gia-startup-dcf-va-cac-phuong-phap",
    "congCu": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-09-19",
    "updatedAt": "2026-09-19"
  },
  {
    "slug": "du-toan-nhiem-vu-tai-tro-natif",
    "kind": "tep",
    "title": "Dự toán nhiệm vụ tài trợ NATIF: phần xin ngân sách và phần đối ứng",
    "excerpt": "Bảng nháp để chuẩn bị hồ sơ tài trợ ứng dụng AI của Quỹ Đổi mới công nghệ quốc gia. Tự kiểm tra 9 điều kiện, chia từng khoản chi theo khoản 1 và 4 Điều 6 Nghị định 265 thành phần xin Quỹ và phần đối ứng, tự cảnh báo khi phần xin vượt 50% tổng kinh phí, vượt 3 tỷ đồng hoặc đối ứng bằng tiền chưa đủ. Kèm kế hoạch 12 tháng có mốc và kết quả đầu ra đo được.",
    "maMau": "NATIF-DU-TOAN-V1",
    "nhom": "mo-hinh-tai-chinh",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Seed",
      "Series A"
    ],
    "doSau": "standard",
    "nhanNgan": "Dự toán và kế hoạch 12 tháng",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fdu-toan-nhiem-vu-tai-tro-natif%2Fv1%2Fdu-toan-nhiem-vu-tai-tro-natif-v1.xlsx?alt=media&token=8ddee5ce-dc47-4f62-8dff-c323e96ab02e",
    "filePath": "mau/du-toan-nhiem-vu-tai-tro-natif/v1/du-toan-nhiem-vu-tai-tro-natif-v1.xlsx",
    "fileName": "du-toan-nhiem-vu-tai-tro-natif-v1.xlsx",
    "fileSize": 21996,
    "fileFormat": "xlsx",
    "fileEnUrl": "",
    "fileEnPath": "",
    "fileEnName": "",
    "fileEnSize": 0,
    "fileEnFormat": "",
    "fileEnPhienBan": 0,
    "lichSu": [],
    "bienSo": [
      "Số tiền từng khoản chi",
      "Đối ứng bằng tiền hay hiện vật",
      "Mốc và tháng thực hiện",
      "Chỉ số đo kết quả"
    ],
    "tabs": [],
    "luuY": [
      "Đây là bảng nháp để tính toán trước khi điền Mẫu I.2 và Phụ lục dự toán chính thức của NATIF, không thay thế mẫu biểu của Quỹ.",
      "Mức 50% và 3 tỷ đồng lấy theo Kế hoạch tài trợ AI 2026. Đợt sau có thể khác: sửa hai ô tham số ở sheet Dự toán.",
      "Cột Gợi ý nguồn dựa trên hướng dẫn kê khai NATIF trình bày tại hội thảo, không phải quy định bắt buộc. Đây không phải tư vấn pháp lý hay tài chính."
    ],
    "baiLienQuan": "tai-tro-ung-dung-ai-natif-2026",
    "congCu": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-10-05",
    "updatedAt": "2026-10-05"
  },
  {
    "slug": "mo-hinh-tai-chinh-36-thang-saas",
    "kind": "tep",
    "title": "Mô hình tài chính 36 tháng đủ 3 báo cáo — bản SaaS",
    "excerpt": "Dự phóng 36 tháng theo tháng, đủ kết quả kinh doanh, lưu chuyển tiền tệ và cân đối kế toán; Dashboard tính nhu cầu vốn, thời điểm tiền thấp nhất và 6 KPI SaaS.",
    "maMau": "FM-CORE-SAAS-L",
    "nhom": "mo-hinh-tai-chinh",
    "nganh": [
      "saas"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed"
    ],
    "doSau": "lite",
    "nhanNgan": "",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fmo-hinh-tai-chinh-36-thang-saas%2Fv1%2Fmo-hinh-tai-chinh-36-thang-saas-v1.xlsx?alt=media&token=b30f5659-3ae1-4bd9-a68c-697b92dd3d83",
    "filePath": "mau/mo-hinh-tai-chinh-36-thang-saas/v1/mo-hinh-tai-chinh-36-thang-saas-v1.xlsx",
    "fileName": "mo-hinh-tai-chinh-36-thang-saas-v1.xlsx",
    "fileSize": 96737,
    "fileFormat": "xlsx",
    "fileEnUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fmo-hinh-tai-chinh-36-thang-saas%2Fen-v1%2Fmo-hinh-tai-chinh-36-thang-saas-en-v1.xlsx?alt=media&token=d77bff3b-5cab-4d63-92db-10abb66c1f1e",
    "fileEnPath": "mau/mo-hinh-tai-chinh-36-thang-saas/en-v1/mo-hinh-tai-chinh-36-thang-saas-en-v1.xlsx",
    "fileEnName": "mo-hinh-tai-chinh-36-thang-saas-en-v1.xlsx",
    "fileEnSize": 94689,
    "fileEnFormat": "xlsx",
    "fileEnPhienBan": 1,
    "lichSu": [],
    "bienSo": [
      "Kế hoạch tuyển dụng: vị trí, lương, tháng bắt đầu",
      "Chi phí cố định hằng tháng: văn phòng, phần mềm, kế toán",
      "Ngân sách marketing và chi phí để có một khách hàng (CAC)",
      "Tỷ lệ khách rời bỏ mỗi tháng và doanh thu mỗi khách (ARPA)",
      "Kế hoạch gọi vốn: số tiền và tháng dự kiến nhận"
    ],
    "tabs": [
      {
        "ten": "Dashboard",
        "moTa": "Chỉ số gọi vốn, tổng hợp 3 năm, KPI ngành, biểu đồ"
      },
      {
        "ten": "Inputs",
        "moTa": "Giả định chung, kế hoạch gọi vốn, chi phí cố định, tài sản"
      },
      {
        "ten": "Nhan_su",
        "moTa": "Kế hoạch tuyển dụng theo nhóm R&D, S&M, G&A"
      },
      {
        "ten": "Module_Nganh",
        "moTa": "Giả định SaaS: CAC, churn, ARPA, giá vốn"
      },
      {
        "ten": "KQKD",
        "moTa": "Kết quả kinh doanh theo tháng"
      },
      {
        "ten": "LCTT",
        "moTa": "Lưu chuyển tiền tệ và burn"
      },
      {
        "ten": "CDKT",
        "moTa": "Bảng cân đối rút gọn"
      },
      {
        "ten": "Kiem_tra",
        "moTa": "Kiểm tra cân đối, cảnh báo tiền âm"
      }
    ],
    "luuY": [
      "Chỉ nhập vào ô nền vàng; các ô còn lại là công thức",
      "Sheet Kiem_tra phải báo OK trước khi gửi cho nhà đầu tư",
      "Thử lùi tháng nhận vốn thêm 2 tháng để xem kế hoạch có âm tiền không",
      "Thuế TNDN và tỷ lệ bảo hiểm là giả định, cần đối chiếu quy định hiện hành",
      "Bản Lite chưa có vay nợ, VAT và tồn kho"
    ],
    "baiLienQuan": "ba-bao-cao-tai-chinh-cua-startup",
    "congCu": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-09-19",
    "updatedAt": "2026-09-19"
  },
  {
    "slug": "so-sanh-term-sheet",
    "kind": "tep",
    "title": "So sánh term sheet: định giá thực, tiền founder nhận và mười điều khoản",
    "excerpt": "Đặt hai hoặc ba term sheet cạnh nhau để thấy lời mời nào thật sự tốt hơn, không chỉ lời mời nào định giá cao hơn. File tính định giá thực sau khi trừ quỹ ESOP, tỷ lệ founder còn lại, số tiền founder nhận ở ba mức giá bán công ty có tính ưu đãi thanh lý, phần mất thêm nếu vòng sau giảm giá, và soát mười điều khoản còn lại với ô tô màu cam khi cần hỏi lại, đỏ khi là cờ đỏ.",
    "maMau": "SO-SANH-TS-V1",
    "nhom": "co-phan",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "doSau": "standard",
    "nhanNgan": "3 term sheet, 3 mức giá bán, 10 điều kho",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fso-sanh-term-sheet%2Fv1%2Fso-sanh-term-sheet-v1.xlsx?alt=media&token=6d55edd0-74ef-4f92-b1d3-f253b8d3ac78",
    "filePath": "mau/so-sanh-term-sheet/v1/so-sanh-term-sheet-v1.xlsx",
    "fileName": "so-sanh-term-sheet-v1.xlsx",
    "fileSize": 18401,
    "fileFormat": "xlsx",
    "fileEnUrl": "",
    "fileEnPath": "",
    "fileEnName": "",
    "fileEnSize": 0,
    "fileEnFormat": "",
    "fileEnPhienBan": 0,
    "lichSu": [],
    "bienSo": [
      "Số tiền đầu tư và định giá trước vòng",
      "Quỹ ESOP phải tạo trước vòng",
      "Bội số và loại ưu đãi thanh lý",
      "Cách chống pha loãng",
      "Ba mức giá bán công ty"
    ],
    "tabs": [
      {
        "ten": "Hướng dẫn",
        "moTa": "Dùng để làm gì, cách điền, quy ước màu và giới hạn của mẫu."
      },
      {
        "ten": "So sánh",
        "moTa": "Ba cột cho ba term sheet: thông tin vòng, định giá thực, ưu đãi thanh lý, chống pha loãng, tiền founder nhận ở ba mức giá bán, mười điều khoản và tóm tắt."
      },
      {
        "ten": "Danh mục",
        "moTa": "Các lựa chọn cho mười điều khoản kèm mức đánh giá, dùng cho danh sách thả xuống và tô màu."
      }
    ],
    "luuY": [
      "Ba term sheet điền sẵn là ví dụ: B định giá cao nhất nhưng founder nhận ít nhất vì ESOP lớn, ưu đãi có tham gia và chống pha loãng toàn phần; C có cam kết mua lại bằng tài sản cá nhân của founder.",
      "Cách tính giống công cụ Đọc term sheet bằng con số trên fundraising.vn, nên số trong file và trên web khớp nhau.",
      "Mẫu giả định một lớp cổ phần ưu đãi của nhà đầu tư vòng này, chưa tính thuế và chi phí giao dịch.",
      "Ở công ty cổ phần Việt Nam, không phải điều khoản nào cũng ghi được vào điều lệ. Hỏi luật sư có kinh nghiệm đầu tư mạo hiểm trước khi ký."
    ],
    "baiLienQuan": "term-sheet-o-viet-nam-rang-buoc-va-thuc-thi",
    "congCu": [
      {
        "slug": "doc-term-sheet",
        "label": "Đọc từng term sheet bằng con số"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Dựng cap table sau vòng"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-10-08",
    "updatedAt": "2026-10-08"
  },
  {
    "slug": "term-sheet-vong-seed",
    "kind": "tep",
    "title": "Mẫu term sheet vòng pre-seed và seed (Việt và Anh)",
    "excerpt": "Term sheet đầu tư bằng cổ phần ưu đãi vào công ty cổ phần Việt Nam, điều khoản cân bằng theo thông lệ: ưu tiên thanh toán 1 lần không tham gia, chống pha loãng bình quân gia quyền diện rộng, founder giữ đa số hội đồng quản trị, danh sách phủ quyết ngắn, không có quyền yêu cầu mua lại. Kèm bảng mười điều khoản thông lệ và cờ đỏ, bốn điểm riêng của Việt Nam, bảng cổ phần dự kiến và kế hoạch sử dụng",
    "maMau": "TERM-SHEET-SEED-V1",
    "nhom": "co-phan",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed"
    ],
    "doSau": "standard",
    "nhanNgan": "Word, Việt và Anh, 33 điều khoản",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fterm-sheet-vong-seed%2Fv1%2Fterm-sheet-vong-seed-v1.docx?alt=media&token=92266736-4158-4770-a5c2-b1a4ed64998b",
    "filePath": "mau/term-sheet-vong-seed/v1/term-sheet-vong-seed-v1.docx",
    "fileName": "term-sheet-vong-seed-v1.docx",
    "fileSize": 17995,
    "fileFormat": "docx",
    "fileEnUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fterm-sheet-vong-seed%2Fen-v1%2Fterm-sheet-vong-seed-en-v1.docx?alt=media&token=bec41dd7-1f86-40eb-93dd-309e4f23e7eb",
    "fileEnPath": "mau/term-sheet-vong-seed/en-v1/term-sheet-vong-seed-en-v1.docx",
    "fileEnName": "term-sheet-vong-seed-en-v1.docx",
    "fileEnSize": 17265,
    "fileEnFormat": "docx",
    "fileEnPhienBan": 1,
    "lichSu": [],
    "bienSo": [
      "Số tiền gọi và định giá trước vòng",
      "Bảng cổ phần trước vòng, gồm SAFE và ESOP",
      "Kế hoạch sử dụng vốn 18 tháng",
      "Cơ cấu hội đồng quản trị mong muốn",
      "Ngày bắt đầu làm việc của từng người sáng lập"
    ],
    "tabs": [
      {
        "ten": "Phần A. Hướng dẫn",
        "moTa": "Mười điều khoản quyết định founder thực sự nhận được gì: mức thông lệ và cờ đỏ; bốn điểm riêng của Việt Nam."
      },
      {
        "ten": "Phần B. Term sheet",
        "moTa": "Thương vụ, quyền kinh tế, quản trị, người sáng lập và ESOP, điều kiện giải ngân, các điều khoản ràng buộc (no-shop, bảo mật, chi phí)."
      },
      {
        "ten": "Phụ lục",
        "moTa": "Bảng cổ phần trước và sau vòng, kế hoạch sử dụng vốn gắn với mốc."
      }
    ],
    "luuY": [
      "Mẫu theo hướng cân bằng, gần với các bộ mẫu chuẩn quốc tế cho vòng sớm, có điều chỉnh cho công ty cổ phần Việt Nam.",
      "Nhà đầu tư nước ngoài có thể phải đăng ký góp vốn, mua cổ phần và mở tài khoản vốn đầu tư trước khi giải ngân; tính thời gian này vào lịch đóng vòng.",
      "Nếu quỹ chỉ đầu tư vào công ty mẹ ở nước ngoài, term sheet sẽ theo luật nơi đặt công ty mẹ.",
      "Mẫu tham khảo, không phải tư vấn pháp lý. Một số điều khoản cần cam kết hợp đồng giữa các cổ đông mới thực thi được; hỏi luật sư cách viết."
    ],
    "baiLienQuan": "term-sheet-o-viet-nam-rang-buoc-va-thuc-thi",
    "congCu": [
      {
        "slug": "doc-term-sheet",
        "label": "Đọc term sheet bằng con số"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Dựng cap table sau vòng"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-10-19",
    "updatedAt": "2026-10-19"
  },
  {
    "slug": "theo-doi-tiep-can-nha-dau-tu",
    "kind": "tep",
    "title": "Bảng theo dõi tiếp cận nhà đầu tư",
    "excerpt": "Quản lý cả vòng gọi vốn trong một file: danh sách quỹ đã tiếp cận, bước hiện tại của từng quỹ, ngày cần nhắc lại tự tính, nhật ký từng lần trao đổi, và phễu cho biết tỷ lệ từ gửi hồ sơ đến gặp mặt, đến thẩm định. Có sẵn 120 dòng, danh sách chọn cho từng cột và cảnh báo quỹ quá hạn chưa liên hệ lại.",
    "maMau": "PIPELINE-NDT-V1",
    "nhom": "quan-ly-goi-von",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "doSau": "standard",
    "nhanNgan": "120 dòng, có phễu tự tính",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Ftheo-doi-tiep-can-nha-dau-tu%2Fv1%2Ftheo-doi-tiep-can-nha-dau-tu-v1.xlsx?alt=media&token=2fffdeb8-0381-4266-88ec-37d78d322e85",
    "filePath": "mau/theo-doi-tiep-can-nha-dau-tu/v1/theo-doi-tiep-can-nha-dau-tu-v1.xlsx",
    "fileName": "theo-doi-tiep-can-nha-dau-tu-v1.xlsx",
    "fileSize": 30100,
    "fileFormat": "xlsx",
    "fileEnUrl": "",
    "fileEnPath": "",
    "fileEnName": "",
    "fileEnSize": 0,
    "fileEnFormat": "",
    "fileEnPhienBan": 0,
    "lichSu": [],
    "bienSo": [
      "Bước hiện tại của từng quỹ",
      "Số ngày chờ trước khi nhắc lại",
      "Nguồn kết nối",
      "Mức ưu tiên"
    ],
    "tabs": [
      {
        "ten": "Hướng dẫn",
        "moTa": "Cách dùng, quy ước màu, và ô đặt số ngày chờ trước khi nhắc lại."
      },
      {
        "ten": "Danh sách quỹ",
        "moTa": "Mỗi dòng một quỹ: bước hiện tại, ngày nhắc lại tự tính, tình trạng quá hạn, việc tiếp theo."
      },
      {
        "ten": "Nhật ký liên hệ",
        "moTa": "Ghi lại từng lần trao đổi: ngày, hình thức, nội dung chính và việc phải làm."
      },
      {
        "ten": "Phễu & tiến độ",
        "moTa": "Số quỹ ở từng bước, tỷ lệ chuyển đổi, và so sánh hiệu quả giữa các nguồn kết nối."
      }
    ],
    "luuY": [
      "Ô «Số ngày chờ trước khi nhắc lại» mặc định 14 ngày. Sửa một ô đó là cả bảng tính lại theo nhịp của bạn.",
      "File chứa tên và cách liên hệ của người thật. Giữ trong nhóm nhỏ, đừng đăng công khai hay chia sẻ đường dẫn mở.",
      "Phễu chỉ phản ánh dữ liệu bạn nhập. Nó cho biết hồ sơ mở được cửa tới đâu, không đánh giá chất lượng doanh nghiệp."
    ],
    "baiLienQuan": "quy-tiep-nhan-ho-so-den-giai-ngan",
    "congCu": [
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ phù hợp"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Rà mức sẵn sàng gọi vốn"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-09-23",
    "updatedAt": "2026-09-23"
  },
  {
    "slug": "thoa-thuan-vesting-co-phan-sang-lap",
    "kind": "tep",
    "title": "Mẫu thoả thuận vesting cổ phần sáng lập (Việt và Anh)",
    "excerpt": "Thoả thuận vesting ngược cho công ty cổ phần Việt Nam: 48 tháng, cliff 12 tháng, quyền mua lại phần chưa vesting theo thứ tự cổ đông sáng lập, người được chỉ định rồi mới tới công ty, tăng tốc kích hoạt kép khi bán công ty. Kèm bảng so sánh lựa chọn thông lệ, thân thiện founder và nhà đầu tư, năm lưu ý theo Luật Doanh nghiệp, ví dụ bằng số và lịch giải phóng cổ phần.",
    "maMau": "VESTING-SL-V1",
    "nhom": "co-phan",
    "nganh": [
      "chung"
    ],
    "giaiDoan": [
      "Pre-seed",
      "Seed"
    ],
    "doSau": "lite",
    "nhanNgan": "Word, Việt và Anh, 10 điều, 3 phụ lục",
    "phienBan": 1,
    "ghiChuPhienBan": "Bản đầu tiên",
    "fileUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fthoa-thuan-vesting-co-phan-sang-lap%2Fv1%2Fthoa-thuan-vesting-co-phan-sang-lap-v1.docx?alt=media&token=3c1b4a8a-ae1a-4384-bfd2-a1f9b9c70a10",
    "filePath": "mau/thoa-thuan-vesting-co-phan-sang-lap/v1/thoa-thuan-vesting-co-phan-sang-lap-v1.docx",
    "fileName": "thoa-thuan-vesting-co-phan-sang-lap-v1.docx",
    "fileSize": 17948,
    "fileFormat": "docx",
    "fileEnUrl": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/mau%2Fthoa-thuan-vesting-co-phan-sang-lap%2Fen-v1%2Fthoa-thuan-vesting-co-phan-sang-lap-en-v1.docx?alt=media&token=d15885f6-ab2e-453d-b4f4-67bde1e9cb9f",
    "fileEnPath": "mau/thoa-thuan-vesting-co-phan-sang-lap/en-v1/thoa-thuan-vesting-co-phan-sang-lap-en-v1.docx",
    "fileEnName": "thoa-thuan-vesting-co-phan-sang-lap-en-v1.docx",
    "fileEnSize": 17073,
    "fileEnFormat": "docx",
    "fileEnPhienBan": 1,
    "lichSu": [],
    "bienSo": [
      "Số cổ phần và tỷ lệ của từng người sáng lập",
      "Ngày bắt đầu làm việc thực tế của từng người",
      "Thời gian vesting và cliff các bên thống nhất",
      "Giá mua lại phần chưa vesting",
      "Định nghĩa lý do chính đáng khi chấm dứt"
    ],
    "tabs": [
      {
        "ten": "Phần A. Hướng dẫn",
        "moTa": "Vesting ngược là gì, bảng các lựa chọn chính, năm lưu ý theo pháp luật Việt Nam, ví dụ bằng số."
      },
      {
        "ten": "Phần B. Thoả thuận",
        "moTa": "Mười điều: định nghĩa, lịch vesting, quyền mua lại khi rời đi, tăng tốc khi bán công ty, hạn chế chuyển nhượng, luật áp dụng."
      },
      {
        "ten": "Phụ lục",
        "moTa": "Lịch giải phóng cổ phần, danh sách cổ đông sáng lập, giấy uỷ quyền ký hồ sơ chuyển nhượng."
      }
    ],
    "luuY": [
      "Ở Việt Nam cổ đông sở hữu cổ phần ngay khi góp vốn, nên mẫu viết theo cơ chế vesting ngược: sở hữu ngay, cam kết bán lại phần chưa vesting khi rời đi.",
      "Bên mua lại ưu tiên là các cổ đông sáng lập còn lại, để tránh giới hạn khi công ty tự mua lại cổ phần của mình theo Luật Doanh nghiệp 2020.",
      "Ô nền cam là chỗ cần điền; đoạn ghi chú in nghiêng giải thích lựa chọn, xoá trước khi ký.",
      "Mẫu tham khảo, không phải tư vấn pháp lý. Làm việc với luật sư trước khi ký, nhất là phần giấy uỷ quyền và giá mua lại."
    ],
    "baiLienQuan": "",
    "congCu": [
      {
        "slug": "chia-co-phan-dong-sang-lap",
        "label": "Chia cổ phần đồng sáng lập"
      },
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Kiểm tra hồ sơ pháp lý"
      }
    ],
    "status": "PUBLISHED",
    "publishedAt": "2026-10-19",
    "updatedAt": "2026-10-19"
  }
];
